import { Col, Container, Row } from "react-bootstrap";
import { useQuery } from "@tanstack/react-query";
import { catalogPageSchema, pageContentSchema } from "@eaf/contracts";
import { ErrorState, LoadingState } from "@eaf/ui";
import { publicApi } from "../api/client";
import { ArtworkCard } from "../components/artwork-card";
import { Seo } from "../components/seo";

export function HomePage() {
  const content = useQuery({
    queryKey: ["content", "home"],
    queryFn: () => publicApi("/content/pages/home", pageContentSchema)
  });
  const catalog = useQuery({
    queryKey: ["catalog", "home"],
    queryFn: () => publicApi("/catalog?page=1&pageSize=12&sort=edited-desc", catalogPageSchema)
  });
  return (
    <main>
      <Seo
        title="Edmund Alan Fain Original Art Collection"
        description="A living archive preserving the visionary art of Edmund Alan Fain."
      />
      <section className="hero">
        <div className="hero__content">
          <p className="eyebrow">A Living Archive</p>
          <h1>EDMUND ALAN FAIN</h1>
          <p>Original Art Collection</p>
          <small>Watercolor · Acrylic · Graphite · Mixed Media</small>
        </div>
      </section>
      <Container as="section" className="home-intro">
        {content.isLoading ? (
          <LoadingState />
        ) : content.isError || !content.data ? (
          <ErrorState>Introductory content is temporarily unavailable.</ErrorState>
        ) : (
          <>
            <h2>{content.data.title}</h2>
            {content.data.blocks
              .filter((block) => block.type === "paragraph")
              .map((block, index) => (
                <p key={index}>{block.type === "paragraph" ? block.text : ""}</p>
              ))}
          </>
        )}
      </Container>
      <Container fluid="xl" as="section" className="featured-gallery">
        <div className="section-heading">
          <p className="eyebrow">The collection</p>
          <h2>Selected works</h2>
        </div>
        {catalog.isLoading ? (
          <LoadingState label="Loading artwork" />
        ) : catalog.isError || !catalog.data ? (
          <ErrorState retry={() => void catalog.refetch()}>
            The collection is temporarily unavailable.
          </ErrorState>
        ) : (
          <Row className="g-4">
            {catalog.data.items.map((artwork) => (
              <Col key={artwork.id} xs={12} sm={6} lg={4} xl={3}>
                <ArtworkCard artwork={artwork} />
              </Col>
            ))}
          </Row>
        )}
      </Container>
    </main>
  );
}
